import { Carriers } from "@redotech/redo-fulfillment-carrier-common/carrier-service-enums";
import { OutboundRate, RateProvider } from "./outbound-labels";

export type CarrierAccountIdentity = Pick<
  OutboundRate,
  "provider" | "carrier_account_id" | "providerInfo"
>;

type ComparableRate = CarrierAccountIdentity &
  Pick<OutboundRate, "carrier" | "service">;

export function canonicalCarrierAccountId(
  rate: CarrierAccountIdentity,
): string {
  if (rate.provider === RateProvider.AMAZON_SHIPPING) {
    return (
      rate.providerInfo?.amazonShipping?.aliasOfCarrierAccountId ||
      rate.carrier_account_id
    );
  }
  return rate.carrier_account_id;
}

export function carrierAccountIdMatchesRate(
  savedCarrierAccountId: string | null | undefined,
  rate: CarrierAccountIdentity,
): boolean {
  if (!savedCarrierAccountId) {
    return false;
  }
  return (
    savedCarrierAccountId === rate.carrier_account_id ||
    savedCarrierAccountId === canonicalCarrierAccountId(rate)
  );
}

function isEasypostAndDirectAmazonPair(
  a: ComparableRate,
  b: ComparableRate,
): boolean {
  if (a.carrier !== Carriers.AMAZON || b.carrier !== Carriers.AMAZON) {
    return false;
  }
  return (
    (a.provider === RateProvider.EASYPOST &&
      b.provider === RateProvider.AMAZON_SHIPPING) ||
    (a.provider === RateProvider.AMAZON_SHIPPING &&
      b.provider === RateProvider.EASYPOST)
  );
}

export function isAliasedAmazonRate(
  a: ComparableRate,
  b: ComparableRate,
): boolean {
  return (
    a.service === b.service &&
    isEasypostAndDirectAmazonPair(a, b) &&
    canonicalCarrierAccountId(a) === canonicalCarrierAccountId(b)
  );
}
